import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";
import { WaButton } from "./WaButton";

const FAQS = [
  { q: "É caro?", a: "O valor depende do tipo de serviço, das condições da instalação e dos materiais necessários. Entre em contato para explicar sua necessidade e solicitar um orçamento." },
  { q: "Vocês atendem minha região?", a: "Atendemos São Paulo Capital, Grande ABC, Baixada Santista e Interior de São Paulo, conforme disponibilidade. Consulte sua localidade pelo WhatsApp." },
  { q: "Fazem hidráulica e elétrica no mesmo atendimento?", a: "Sim. A HidroPro Serviços Técnicos oferece serviços hidráulicos e elétricos. A possibilidade de realizar ambos no mesmo atendimento depende da necessidade e do escopo do serviço." },
  { q: "Como funciona o orçamento?", a: "Você explica sua necessidade pelo WhatsApp. Nossa equipe analisa as informações disponíveis e orienta sobre os próximos passos para elaboração do orçamento." },
  { q: "Posso enviar fotos ou vídeos do problema?", a: "Sim. Você pode enviar fotos e vídeos pelo WhatsApp para ajudar nossa equipe a compreender inicialmente a situação. Dependendo do serviço, poderá ser necessária uma avaliação técnica no local." },
];

export default function Faq() {
  return (
    <section id="faq" className="bg-white py-16 md:py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
        <div className="lg:col-span-5">
          <SectionHead index="08" label="Perguntas frequentes" title="Escopo, valores e condições apresentados antes da contratação." />
          <Reveal delay={0.2}>
            <div className="mt-8 rounded-2xl border border-[rgba(10,92,140,0.2)] bg-paper p-6">
              <p className="font-display text-base font-bold text-[#1A1A1A]">Ainda tem dúvida?</p>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">Resolvemos direto pelo WhatsApp.</p>
              <div className="mt-4">
                <WaButton testId="hidropro-faq-whatsapp-button" label="Solicitar atendimento pelo WhatsApp" />
              </div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible data-testid="hidropro-faq-accordion" className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-[rgba(10,92,140,0.15)]">
                  <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-[#1A1A1A] hover:no-underline hover:text-[#0A5C8C] sm:text-lg">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600 sm:text-base">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
